import styled from 'styled-components'

import { Button as ButtonBase } from '@application/Interfaces/Molecules/Button'
import Container from '@mui/material/Container'
import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const Wrapper = styled(Container)`
    padding: 50px 20px;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 100px 0px;
    }
`

export const Title = styled.h3`
    ${(props) => props.theme.typo.bodyL};
    ${(props) => props.theme.fontWeight.regular};
    color: ${(props) => props.theme.color.a500};
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 10px;
`

export const CategoryTitle = styled.h2`
    ${(props) => props.theme.typo.displayXL};
    ${(props) => props.theme.fontWeight.regular};
    color: ${(props) => props.theme.color.p500};
    text-align: center;
    margin-bottom: 20px;
`

export const CategoryDescription = styled.p`
    ${(props) => props.theme.typo.bodyL};
    ${(props) => props.theme.fontWeight.regular};
    color: ${(props) => props.theme.color.g500};
    line-height: 180%;
    text-align: center;
    margin-bottom: 20px;
`

export const Link = styled(LinkBase)`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.regular};
    color: ${(props) => props.theme.color.g600};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`

export const Button = styled(ButtonBase)`
    max-width: 364px;

    button {
        margin-top: 10px;
        width: 100%;
    }

    @media ${(props) => props.theme.query.mobile} {
        width: 100%;
    }
`
